module.exports = __webpack_public_path__ + "static/media/llama-head-01.e8044f88.png";